// Import React
import React from "react";

// Import React Icons
import { FiPhone, FiMapPin } from "react-icons/fi";
import InstagramIcon from "@mui/icons-material/Instagram";

const TopInfoBar = () => {
  // URLs / Enlaces
  const INSTAGRAM_URL = "https://instagram.com/prehouseuruguay";
  const MAPS_URL =
    "https://www.google.com/maps?ll=-34.786551,-56.002902&z=15&t=m&hl=es&gl=UY&mapclient=embed&q=34%C2%B047%2711.6%22S+56%C2%B000%2701.2%22W+-34.786556,+-56.000333@-34.7865556,-56.00033329999999";

  // Teléfono para href: usar formato internacional sin espacios
  const TEL_DISPLAY = "2696 61 55";
  const TEL_HREF = "tel:+59826966155";

  const handlePhoneClick = () => {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      event: "phone_call",
      phone_number: TEL_HREF,
      link_text: TEL_DISPLAY,
      page_location: window.location.href,
    });
  };

  return (
    <div className="w-full bg-gray-900 text-white text-sm py-2">
      {/* Contenedor centrado */}
      <div className="max-w-screen-xl mx-auto px-4 md:px-12 flex flex-col md:flex-row items-center justify-between">
        {/* Teléfono */}
        <a
          href={TEL_HREF}
          onClick={handlePhoneClick}
          className="flex items-center gap-2 mb-1 md:mb-0 text-white no-underline hover:text-white focus:text-white"
          aria-label={`Llamar al ${TEL_DISPLAY}`}
          title={`Llamar al ${TEL_DISPLAY}`}
        >
          <FiPhone className="text-[#FFBA00]" />
          <span>{TEL_DISPLAY}</span>
        </a>

        {/* Dirección */}
        <a
          href={MAPS_URL}
          target="_blank"
          rel="noopener noreferrer"
          className="flex items-center gap-2 mb-1 md:mb-0 text-white no-underline hover:text-white focus:text-white"
          aria-label="Abrir ubicación en Google Maps"
          title="Abrir ubicación en Google Maps"
        >
          <FiMapPin className="text-[#FFBA00]" />
          <span>Ruta 101 esq Los Aromos</span>
        </a>

        {/* Instagram */}
        <a
          href={INSTAGRAM_URL}
          target="_blank"
          rel="noopener noreferrer"
          className="flex items-center gap-2 text-white no-underline hover:text-white focus:text-white"
          aria-label="Abrir Instagram de PreHouse Uruguay"
          title="Abrir Instagram de PreHouse Uruguay"
        >
          <InstagramIcon className="text-[#FFBA00]" />
          <span>@prehouseuruguay</span>
        </a>
      </div>
    </div>
  );
};

// Exportar el componente
export default TopInfoBar;
